import { VisitPatient } from '@dreryk/egabinet-visit-frontend-api';

import { Heading, Scroll, StyledFlex } from '@dreryk/react-components';
import { useFormController } from '@dreryk/react-common';

import { VisitId } from '~libs.shared.visit';

import { educationalMaterialsTranslationKeys } from './translations';
import { EducationalMaterialsTable } from './table/EducationalMaterialsTable';
import { StyledActionInput } from './EducationalMaterialsPanel.styled';

type EducationalMaterialFormBean = {
   searchText: string | null;
};

type EducationalMaterialsPanelProps = {
   patientEmail?: VisitPatient['emailAddress'];
   visitId: VisitId;
};

export const EducationalMaterialsPanel = (props: EducationalMaterialsPanelProps): JSX.Element => {
   const { register, watch } = useFormController<EducationalMaterialFormBean>({
      searchText: null,
   });

   const searchText = watch('searchText');

   return (
      <Scroll testId={'educationalMaterials'}>
         <StyledFlex gap={12}>
            <Heading
               testId={'educationalMaterials'}
               type={'h1'}
               content={educationalMaterialsTranslationKeys.title}
               bold
            />
            <StyledActionInput
               controller={register('searchText')}
               testId={'searchText'}
               placeholder={educationalMaterialsTranslationKeys.form.actionInput.placeholder}
               autoFocus
               compact
            />
         </StyledFlex>
         <EducationalMaterialsTable searchText={searchText} visitId={props.visitId} patientEmail={props.patientEmail} />
      </Scroll>
   );
};
